import React from "react";
import { Icons } from "assets/icons";

function ListViewTypeToggler({ className = "", viewMode, onChange }) {
  const { gridTypeTable, gridTypeTable2, listTypeTable, listTypeTable2 } =
    Icons || {};

  return (
    <div
      className={`btn-group table-type-toggler btn-group-sm ${className}`}
      role="group"
      aria-label="View mode toggle"
    >
      <button
        type="button"
        className={`main_btn btn ${viewMode === "grid" ? "active" : ""} px-2`}
        onClick={() => onChange("grid")}
        title="Grid View"
      >
        <img
          src={gridTypeTable}
          className="main_icon"
          width={24}
          height={24}
          alt={"Grid View"}
        />
        <img
          src={gridTypeTable2}
          className="hover_icon"
          width={24}
          height={24}
          alt={"Grid View"}
        />
      </button>

      <button
        type="button"
        className={`btn main_btn ${viewMode === "list" ? "active" : ""} px-2`}
        onClick={() => onChange("list")}
        title="List View"
      >
        <img
          src={listTypeTable2}
          className="hover_icon"
          width={24}
          height={24}
          alt={"List View"}
        />
        <img
          className="main_icon"
          src={listTypeTable}
          width={24}
          height={24}
          alt={"List View"}
        />
      </button>
    </div>
  );
}

export default ListViewTypeToggler;
